#import "../../../../common/graphql/EntityDocumentsFields.graphql"
query Traveler($id: UUID!) {
  traveler(id: $id) {
    id
    __typename
    _urgencyLevel
    firstName
    _isTripBreakdownAllowed
    _isApproved
    companyOrLastName
    _sortName
    vendorNumber
    frequentFlyerNumber
    isIsleSeatPreferred
    isWindowSeatPreferred
    travelerDepartmentId
    department {
      name
    }
    travelPolicyId
    userOccupationTitleId
    userOccupation {
      userOccupationTitle
    }
    _isUpdatable
    _isUpdateTravelerOverride
    _isDeletable
    _rowTimestamp
    _isAliasOriginalNameViewable
    _isAliasInvoked
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    isDraft
    _isStagedApprovalRequest
    _isApprovalRevocable
    _fullName
    travelerCompanionAmount
    travelerCompanionTickets
    isEconomyClassPreferred
    isFirstClassPreferred
    isBusinessClassPreferred
    isCharterClassPreferred
    isPremiumClassPreferred
    travelerCompanionMasterId
    travelerHost {
      id
      isEconomyClassPreferred
      isBusinessClassPreferred
      isFirstClassPreferred
    }
    travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
      nodes {
        id
        _rowTimestamp
        addressLine1
        addressLine2
        cityName
        countryId
        stateRegionId
        stateRegion {
          stateRegionDescription
          stateRegion
          country {
            country
          }
        }
        country {
          country
        }
        postalCode
        telephoneNumber
        emailAddress
        isGroundTransferAddress
        isDeliveryAddress
        isPrimary
      }
    }
    travelerDietaryRequirementsByTravelerId(orderBy: [ID_ASC]) {
      nodes {
        id
        description
        _rowTimestamp
        _isDeletable
        dietaryRequirement {
          id
          isDescriptionRequired
        }
      }
    }
    _travelPolicyAllowances(orderBy: SORT_ORDER_ASC) {
      nodes {
        id
        expenditureType {
          expenditureType
        }
        allowanceOverrideAmount
        _allowanceDescription
        isAllowanceCustomizable
        _travelerPolicyAllowanceRowTimestamp
        _travelerPolicyAllowanceId
      }
    }
    travelPolicy {
      id
      isCompanion
      description
      isContractual
      isDefaultCustomizable
      companyCurrency {
        isoCode
      }
    }
    travelerHistoriesByEntityId {
      nodes {
        tenantUserName
        pointInTimeDate
        crudOperation
      }
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
    userMessagesByEntityId {
      totalCount
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
    approvalHistorySignaturesByEntityId(
      orderBy: SORT_ORDER_ASC
      filter: {
        not: {
          isApproved: { equalTo: false }
          isRejected: { equalTo: false }
          isRequested: { equalTo: false }
        }
      }
    ) {
      nodes {
        id
        additionalInformation
        digitalSignature
        actionDate
        isApproved
        isRejected
        isRequested
        userName
        entityDocumentId
        userOccupationTitle
        userSignatureDocument {
          id
          _downloadLink
          fileIndexInformation
          fileReference
          iconType
        }
      }
    }
  }
}
